var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"lk"}},[_c('span',{class:_vm.classStyle,on:{"click":function($event){return _vm.expandParent('detail', _vm.item)}}},[_vm._v(" "+_vm._s('查看详情')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }